import { Component, Input } from '@angular/core';
import { LabelAtomComponent } from '../../atoms/label-atom/label-atom.component';
import { InputAtomComponent } from '../../atoms/input-atom/input-atom.component';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ls-form-field-molecule',
  standalone: true,
  imports: [
    LabelAtomComponent,
    InputAtomComponent,
    SkeletonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './form-field-molecule.component.html',
  styleUrl: './form-field-molecule.component.scss',
})
export class FormFieldMoleculeComponent {
  @Input() labelText = ''; // Texto del label
  @Input() labelFor?: string; // ID del input al que el label está asociado
  @Input() inputType?: string; // Tipo del input
  @Input() inputPlaceholder?: string; // Placeholder del input
  @Input() inputClass = 'w-full'; // Clases CSS adicionales del input
  @Input() labelClass = 'block mb-2'; // Clases CSS adicionales del label
  @Input() required = false; // Indica si el campo es requerido
  @Input() disabled = false;
  @Input() loading = false; // Indica si el campo es requerido
  @Input() formName!: string;
  @Input() min?: string;
  @Input() max?: string;

  @Input() position: 'left' | 'right' = 'left';
  @Input() icon = 'pi-search';
  @Input() showIcon = false;
  
  @Input() textError = '';

  @Input() group!: FormGroup;
}
